export default __webpack_public_path__ + "static/media/tim-apple.5f4f406e.png";